import Axios from './axios_wrapper'

export function createOperation(data) {

  return Axios({
    url: `/operations`,
    method: 'POST',
    data
  })
}

export function getOperations(page) {
  return Axios({
    url: `/operations`,
    method: 'GET',
    page
  })
}

export function getOperationById({ id }) {
  return Axios({
    url: `/operations/${id}`,
    method: 'GET'
  })
}

export function deleteOperation({id}) {
  return Axios({
    url: `/operations/${id}`,
    method: 'DELETE'
  })
}

export function updateOperation({id, data}) {
  return Axios({
    url: `/operations/${id}`,
    method: 'PATCH',
    data
  })
}

export function getUserOperations(userId, page) {
  return Axios({
    url: `/users/${userId}/operations`,
    method: 'GET',
    page
  })
}

export function uploadOperationsCsv (data) {
  return Axios({
    url: `/csv/operations`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function nurseUploadOperationsCsv (data) {
  return Axios({
    url: `/csv/nurseoperations`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function adminUploadOperationsCsv (data) {
  return Axios({
    url: `/admin/csv/operations`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function createPatientsWithOperations (data) {
  return Axios({
    url: `/patients_with_operations`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function getOperationTypes() {
  return Axios({
    url: `/operation_types`,
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/operations.js
// module id = null
// module chunks = 